import { Box, Container, Grid, Typography, Card, CardContent, useTheme } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Seo from '../components/Seo';

const ContactHeader = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.default,
        pt: { xs: 10, md: 12 },
        pb: { xs: 6, md: 8 },
        textAlign: 'center',
      }}
    >
      <Container>
        <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="subtitle1" sx={{ maxWidth: 800, mx: 'auto', mb: 4, color: theme.palette.text.secondary }}>
          Have questions about SOLVENDA? We're here to help! Get in touch with our team and we'll get back to you as soon as possible.
        </Typography>
      </Container>
    </Box>
  );
};

const ContactInfo = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 8,
        bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#ffffff',
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 5 }}>
          Contact Information
        </Typography>
        
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={4}>
            <Card sx={{ 
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-10px)',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
              } 
            }}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', p: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    bgcolor: `${theme.palette.primary.main}15`,
                    color: theme.palette.primary.main,
                    mr: 2,
                  }}
                >
                  <EmailIcon fontSize="medium" />
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Email Us
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    <a 
                      href="mailto:fabio_marku@hotmail.com" 
                      style={{ 
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                      }}
                    >
                      fabio_marku@hotmail.com
                    </a>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ 
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-10px)',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
              } 
            }}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', p: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    bgcolor: `${theme.palette.primary.main}15`,
                    color: theme.palette.primary.main,
                    mr: 2,
                  }}
                >
                  <PhoneIcon fontSize="medium" />
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Call Us
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    <a 
                      href="tel:+355696546099" 
                      style={{ 
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                      }}
                    >
                      +355 69 654 6099
                    </a>
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    <a 
                      href="tel:+355692098563" 
                      style={{ 
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                      }}
                    >
                      +355 69 209 8563
                    </a>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Typography variant="h4" component="h3" gutterBottom align="center" sx={{ mt: 8, mb: 4 }}>
          Our Locations
        </Typography>
        
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-10px)',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
              } 
            }}>
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center'}}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      bgcolor: `${theme.palette.primary.main}15`,
                      color: theme.palette.primary.main,
                      mr: 2,
                    }}
                  >
                    <LocationOnIcon fontSize="medium" />
                  </Box>
                  <Typography variant="h5" fontWeight={600}>
                    Tirane
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-10px)',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
              } 
            }}>
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      bgcolor: `${theme.palette.primary.main}15`,
                      color: theme.palette.primary.main,
                      mr: 2,
                    }}
                  >
                    <LocationOnIcon fontSize="medium" />
                  </Box>
                  <Typography variant="h5" fontWeight={600}>
                    Lezhe
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const ContactPage = () => {
  return (
    <div>
      <Seo
        title="Contact SOLVENDA | Get Support for ISP Management Solutions"
        description="Contact the SOLVENDA team for information about our ISP management solutions, pricing, demos or support. We're here to help your Internet Service Provider business succeed."
        keywords="Contact SOLVENDA, ISP management support, ISP software contact, SOLVENDA demo, ISP billing support, Albania ISP contact"
        path="/contact"
      />
      <Box>
        <ContactHeader />
        <ContactInfo />
      </Box>
    </div>
  );
};

export default ContactPage; 